import { render, staticRenderFns } from "./btnCom.vue?vue&type=template&id=3ea99e2a&scoped=true"
import script from "./btnCom.vue?vue&type=script&lang=js"
export * from "./btnCom.vue?vue&type=script&lang=js"
import style0 from "./btnCom.vue?vue&type=style&index=0&id=3ea99e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea99e2a",
  null
  
)

export default component.exports